<div class="time-range-slider">
  <ng-container>
  <!-- Header with Add Group button -->
  <div class="slider-header form-header form-header-subsection" data-automation="sliderHeader" role="heading">
    <h4>{{ 'common.product.grouped_offer_hours' | translate }}</h4>

    <button *ngIf="!isViewMode"
            data-automation="addGroupButton"
            class="icon-btn x-btn-primary"
            (click)="openAddGroupModal()"
            aria-label="{{ 'common.product.grouped_offer_hours.create_group' | translate }}">
      <mat-icon>add</mat-icon>
      {{ 'common.product.grouped_offer_hours.create_group' | translate }}
    </button>
  </div>

  <!-- Timeline Slider -->
  <div class="timeline-container" role="group" aria-labelledby="timeRangeTitle">
    <!-- Hour labels -->
    <div data-automation="hourLabels" class="hour-labels" role="presentation">
      <span data-automation="hourLabel"
            *ngFor="let hour of hours"
            class="hour-label"
            aria-label="{{ hour.toString().padStart(2, '0') }} hours">
        {{ hour.toString().padStart(2, '0') }}:00
      </span>
    </div>

    <!-- Slider track -->
    <div class="slider-track" #sliderTrack role="application">
      <!-- Tick marks -->
      <div class="tick-marks">
        <span *ngFor="let hour of hours" class="tick-mark"></span>
      </div>

      <!-- Interval bars -->
      <div class="intervals-layer"
           data-automation="timeRangeSlider">
        <ng-container *ngFor="let group of groups">
          <div *ngFor="let interval of group.intervals"
               data-automation="intervalBar"
               class="interval-bar"
               [style.left.%]="getPositionPercent(interval.start)"
               [style.width.%]="getWidthPercent(interval.start, interval.end)"
               [style.background-color]="group.color"
               [style.color]="getContrastColor(group.color)"
               role="group"
               [attr.aria-label]="group.groupName + ' interval from ' + minutesToTime(interval.start) + ' to ' + minutesToTime(interval.end)">

            <span #intervalLabel
                  [matTooltip]="group.groupName"
                  matTooltipPosition="above"
                  class="interval-label">
              {{ group.groupName }}
            </span>

            <!-- Start handle -->
            <div *ngIf="!isViewMode"
                 class="handle handle-start"
                 data-automation="handleStart"
                 [attr.data-tooltip]="minutesToTime(interval.start)"
                 (mousedown)="onHandleMouseDown($event, interval, 'start')"
                 role="slider"
                 [attr.aria-label]="'Start time: ' + minutesToTime(interval.start)"
                 [attr.aria-valuemin]="0"
                 [attr.aria-valuemax]="1440"
                 [attr.aria-valuenow]="interval.start">
            </div>

            <!-- End handle -->
            <div *ngIf="!isViewMode"
                 class="handle handle-end"
                 data-automation="handleEnd"
                 [attr.data-tooltip]="minutesToTime(interval.end)"
                 (mousedown)="onHandleMouseDown($event, interval, 'end')"
                  role="slider"
                  [attr.aria-label]="'End time: ' + minutesToTime(interval.end)"
                  [attr.aria-valuemin]="0"
                  [attr.aria-valuemax]="1440"
                  [attr.aria-valuenow]="interval.end">
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #noSpaceModal>
        <mat-dialog-content data-automation="noAvailableSpaceMessage">
          {{ 'common.product.grouped_offer_hours.no_space_available' | translate }}
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button data-automation="submitNoAvailableSpaceMessage" class="icon-btn x-btn-secondary" mat-dialog-close>
            <mat-icon>done</mat-icon>
            {{ 'common.button.ok' | translate }}
          </button>
        </mat-dialog-actions>
      </ng-template>

    </div>
  </div>

  <!-- Configured Groups Section -->
  <div class="configured-groups" data-automation="configureGroups">
    <h4>{{ 'common.product.grouped_offer_hours.configured_groups' | translate }}</h4>

    <div class="groups-list">
      <div *ngFor="let group of groups" class="group-item" data-automation="groupItem">
        <div class="group-header">
          <div class="group-info">
            <span data-automation="groupNameColorIndicator" class="color-indicator" [style.background-color]="group.color"></span>
            <span #groupName [matTooltip]="group.groupName" matTooltipPosition="above" data-automation="groupName" class="group-name">{{ group.groupName }}</span>
          </div>
          <div *ngIf="!isViewMode" class="group-actions">
            <button data-automation="addIntervalButton" class="icon-btn x-btn-primary" (click)="addInterval(group)">
              <mat-icon>add</mat-icon>
              {{ 'common.product.grouped_offer_hours.create_interval' | translate }}
            </button>
            <button data-automation="removeGroupTrashButton" class="x-btn-secondary" (click)="removeGroup(group.id)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="intervals-chips" data-automation="chipsList">
          <div *ngFor="let interval of group.intervals">
            <mat-chip-set>
              <mat-chip data-automation="intervalChip" class="interval-chip" [class.new-interval]="interval.isNew" [style.color]="getContrastColor(group.color)">
                {{ minutesToTime(interval.start) }} - {{ minutesToTime(interval.end) }}
                <button *ngIf="!isViewMode" data-automation="chipRemoveButton" class="chip-remove-button" matChipRemove (click)="removeInterval(group, interval.id)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </div>

      <div *ngIf="groups.length === 0" class="empty-state" data-automation="emptyStateForGroup">
        <p>{{ 'common.product.grouped_offer_hours.no_groups_configured' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Add Group Modal -->
  <div class="modal-overlay" *ngIf="showAddGroupModal" (click)="closeAddGroupModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 data-automation="addGroupModalHeader">{{ 'common.product.grouped_offer_hours.create_group' | translate }}</h3>
      </div>

      <div class="modal-body">
        <div class="form-entry">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ 'common.product.grouped_offer_hours.group_name_label' | translate }}</mat-label>
              <input
                data-automation="groupNameInput"
                matInput
                type="text"
                required
                name="groupName"
                pattern="^[^\s]+(\s+[^\s]+)*$"
                placeholder="{{ 'common.product.grouped_offer_hours.group_name_placeholder' | translate }}"
                [formControl]="newGroupName"
                (keyup.enter)="addGroup()"
              />
              <mat-error *ngIf="newGroupName.invalid" class="alert alert-danger">
                <mat-error *ngIf="newGroupName.errors.required">
                  <span class="input-title"></span>
                  <span>{{ 'common.validation.required' | translate }}</span>
                </mat-error>
              </mat-error>
            </mat-form-field>
        </div>

      </div>

      <div class="modal-footer">
        <button data-automation="cancelCreateGroupButton" class="icon-btn x-btn-secondary" (click)="closeAddGroupModal()">
          <mat-icon>clear</mat-icon>
          {{ 'common.button.cancel' | translate }}
        </button>
        <button data-automation="createGroupButton" [disabled]="newGroupName.invalid" class="icon-btn x-btn-primary" (click)="addGroup()">
          <mat-icon>done</mat-icon>
          {{ 'common.button.create' | translate }}
        </button>
      </div>
    </div>
  </div>
  </ng-container>
</div>
